import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import Pagination from '../../components/Pagination';
import StatusHandler from '../../components/StatusHandler';
import { TableColumn } from '../../components/ui/Table';
import { SubscriberDownladed } from '../../models/subscriber';
import useReferredUsers from './useReferredUsers';
import NewTable from '../../components/ui/NewTable';
import { ReferrerTable } from '../../models/referrer';
import { ReferrerDownloadedData, ReferrerToReferrerTable } from '../../utils/referrer';

type Props = {
  userRole?: string;
};

const ReferredUsers = ({ userRole = 'Referrals' }: Props) => {
  const [usersData, setUsersData] = useState<{
    headers: TableColumn<ReferrerTable>[];
    data: ReferrerTable[];
  }>({ headers: [], data: [] });

  const [usersDownloadedData, setUsersDownloadedData] = useState<{
    data: SubscriberDownladed[];
  }>({ data: [] });
  const { users, isLoading, error } = useReferredUsers();

  const [currentPage, setCurrentPage] = useState<number | undefined>();
  const [totalPages, setTotalPages] = useState<number | undefined>();

  let currPage = 1;
  let contentPerPage = 20;

  const resetPageSize = () => {
    if (users) {
      setCurrentPage(1);
      setTotalPages(Math.ceil(users.length / contentPerPage));
    }
  };

  const findSlicingIndex = () => {
    const startIndex = currPage * contentPerPage - contentPerPage;
    const endIndex = startIndex + contentPerPage;
    return { startIndex, endIndex };
  };

  useEffect(() => {
    if (users) {
      resetPageSize();
      getPaginatedData();
      setUsersDownloadedData(ReferrerDownloadedData(users));
    }
  }, [users]);

  /* Local Pagination feature */

  const getPaginatedData = () => {
    let { startIndex, endIndex } = findSlicingIndex();
    const paginatedData = users.slice(startIndex, endIndex);
    setUsersData(ReferrerToReferrerTable(paginatedData));
  };

  const nextPage = () => {
    if (currentPage && totalPages && currentPage < totalPages) {
      currPage = currentPage + 1;
      setCurrentPage(currPage);
      getPaginatedData();
    }
  };

  const prevPage = () => {
    if (currentPage && totalPages && currentPage > 1) {
      currPage = currentPage - 1;
      setCurrentPage(currPage);
      getPaginatedData();
    }
  };

  const downloadCSV = {
    fileName: "Sporti Users",
    data: usersDownloadedData.data,
  }

  return (
    <>
      <div className="flex flex-col w-full h-full overflow-auto px-6 scrollbar-hide mb-4">
        <h1 className="text-secondary-main text-[50px] my-6 first-letter:uppercase">
          {userRole}
        </h1>
        <StatusHandler isLoading={isLoading} error={error}>
          <>
            <NewTable data={usersData?.data} columns={usersData?.headers} 
              downloadCSV={downloadCSV} />
            <Pagination
              className="my-4"
              currentPage={currentPage}
              totalPages={totalPages}
              nextPage={nextPage}
              prevPage={prevPage}
            />
          </>
        </StatusHandler>
      </div>
    </>
  );
};

export default ReferredUsers;
